import React, { useState } from "react";
import "../styles/MatrimonialRegistrationPage.css";
import bhriguLogo from "../assets/images/bhrigu-logo.gif";
import pic1 from "../assets/images/matrimonial-pic1.png";
import pic2 from "../assets/images/matrimonial-pic2.png";
import pic3 from "../assets/images/matrimonial-pic3.png";

const MatrimonialRegistrationPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    time: "",
    placeOfBirth: "",
    gender: "",
    education1: "",
    education2: "",
    profession: "",
    income: "",
    height: "",
    weight: "",
    complexion: "",
    bloodGroup: "",
    gotra: "",
    kuldevi: "",
    fatherName: "",
    fatherOccupation: "",
    motherName: "",
    motherOccupation: "",
    sibling1: "",
    sibling2: "",
    sibling3: "",
    dadaji: "",
    dadiji: "",
    nanaji: "",
    naniji: "",
    reference1: "",
    reference2: "",
    reference3: "",
    reference4: "",
    correspondenceAddress: "",
    email: "",
    phone: "",
  });
  const [uploadedImages, setUploadedImages] = useState({
    img1: null,
    img2: null,
    img3: null,
  });
  const [errors, setErrors] = useState({});
  const [imageErrors, setImageErrors] = useState("");

  const requiredFields = [
    "name", "dob", "time", "placeOfBirth", "gender", "education1", "profession",
    "income", "height", "weight", "complexion", "bloodGroup", "gotra", "kuldevi",
    "fatherName", "motherName", "dadaji", "dadiji", "nanaji", "naniji",
    "correspondenceAddress", "email", "phone"
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    let tempErrors = {};
    requiredFields.forEach(field => {
      if (!formData[field]?.trim()) {
        tempErrors[field] = "This field is required";
      }
    });
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isFormValid = validate();

    // 🔴 Image validation
    if (!uploadedImages.pic1 || !uploadedImages.pic2 || !uploadedImages.pic3) {
      setImageErrors("All three photographs are required");
      return;
    } else {
      setImageErrors("");
    }

    if (!isFormValid) return;

    alert("Form submitted successfully! Your Registration ID is BL000001.");
    // API call here
  };


  const handlePhotoChange = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setUploadedImages(prev => ({
        ...prev,
        [key]: previewUrl,
      }));
      setImageErrors("");
    }
  };


  return (
    <div className="matrimonial-page">
      <div className="container-matrimonial">
        {/* LEFT PANEL */}
        <div className="col-70 profileleftpanel">
          <div className="row">
            <div className="col-15">
              <button>Self</button>
              <br />
              <button>Other</button>
            </div>
            <div className="col-75 animated-title">
              <h2>Registration for Bandhan Sutra</h2>
            </div>
          </div>

          <div className="row">
            {/* LEFT FORM COLUMN */}
            <div className="col-50">
              <div className="form-row">
                <input type="text" placeholder="Name *" name="name" onChange={handleChange} />
                {errors.name && <span className="error">{errors.name}</span>}
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-60">
                    <input type="text" placeholder="Date of Birth *" name="dob" onChange={handleChange} />
                    {errors.dob && <span className="error">{errors.dob}</span>}
                  </div>
                  <div className="col-40">
                    <input type="text" placeholder="Time *" name="time" onChange={handleChange} />
                    {errors.time && <span className="error">{errors.time}</span>}
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-60">
                    <input type="text" placeholder="Place of Birth *" name="placeOfBirth" onChange={handleChange} />
                    {errors.placeOfBirth && <span className="error">{errors.placeOfBirth}</span>}</div>
                  <div className="col-40">
                    <input type="text" placeholder="Male / Female *" name="gender" onChange={handleChange} />
                    {errors.gender && <span className="error">{errors.gender}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <input type="text" placeholder="Highest Education 1 *" name="education1" onChange={handleChange} />
                {errors.education1 && <span className="error">{errors.education1}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Highest Education 2" name="education2" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Profession *" name="profession" onChange={handleChange} />
                {errors.profession && <span className="error">{errors.profession}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Monthly Income in Rs. *" name="monthlyIncome" onChange={handleChange} />
                {errors.monthlyIncome && <span className="error">{errors.monthlyIncome}</span>}</div>

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <input type="text" placeholder="Height in Feet *" name="height" onChange={handleChange} />
                    {errors.height && <span className="error">{errors.height}</span>}</div>
                  <div className="col-48">
                    <input type="text" placeholder="Weight in Kg *" name="weight" onChange={handleChange} />
                    {errors.weight && <span className="error">{errors.weight}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <input type="text" placeholder="Complexion *" name="complexion" onChange={handleChange} />
                    {errors.complexion && <span className="error">{errors.complexion}</span>}
                  </div>
                  <div className="col-48">
                    <input type="text" placeholder="Blood Group *" name="bloodGroup" onChange={handleChange} />
                    {errors.bloodGroup && <span className="error">{errors.bloodGroup}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <input type="text" placeholder="Gotra *" name="gotra" onChange={handleChange} />
                    {errors.gotra && <span className="error">{errors.gotra}</span>}</div>
                  <div className="col-48">
                    <input type="text" placeholder="Kuldevi *" name="kuldevi" onChange={handleChange} />
                    {errors.kuldevi && <span className="error">{errors.kuldevi}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <input type="text" placeholder="Father’s Name *" name="fatherName" onChange={handleChange} />
                {errors.fatherName && <span className="error">{errors.fatherName}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Occupation" name="fatherOccupation" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Mother’s Name *" name="motherName" onChange={handleChange} />
                {errors.motherName && <span className="error">{errors.motherName}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Occupation" name="motherOccupation" onChange={handleChange} /></div>
            </div>

            {/* RIGHT FORM COLUMN */}
            <div className="col-50">
              <div className="form-row">
                <input type="text" placeholder="Sibling 1" name="sibling1" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Sibling 2" name="sibling2" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Sibling 3" name="sibling3" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Dadaji *" name="dadaji" onChange={handleChange} />
                {errors.dadaji && <span className="error">{errors.dadaji}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Dadiji *" name="dadiji" onChange={handleChange} />
                {errors.dadiji && <span className="error">{errors.dadiji}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Nanaji *" name="nanaji" onChange={handleChange} />
                {errors.nanaji && <span className="error">{errors.nanaji}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Naniji *" name="naniji" onChange={handleChange} />
                {errors.naniji && <span className="error">{errors.naniji}</span>}</div>

              <div className="form-row">
                <input type="text" placeholder="References" name="reference1" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="References" name="reference2" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="References" name="reference3" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="References" name="reference4" onChange={handleChange} /></div>

              {/* <div className="form-row"><input type="text" placeholder="Correspondence Address" /></div> */}
              <div className="form-row">
                <textarea placeholder="Correspondence Address *" rows={5} className="form-textarea" name="correspondenceAddress" onChange={handleChange} />
                {errors.correspondenceAddress && <span className="error">{errors.correspondenceAddress}</span>}</div>
              {/* <div className="form-row"><input type="text" placeholder="Correspondence Address" /></div> */}

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <input type="email" placeholder="Email *" name="email" onChange={handleChange} />
                    {errors.email && <span className="error">{errors.email}</span>}</div>
                  <div className="col-48">
                    <input type="tel" placeholder="Phone *" name="phone" onChange={handleChange} />
                    {errors.phone && <span className="error">{errors.phone}</span>}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="col-30">
          <div className="col-100 logo-div text-center">
            <img src={bhriguLogo} alt="Bhrigu" />
          </div>
          <div className="row matrimonial-img-div">
            <div className="martinomial-img">
              <div className="row">
                <div className="leftpanelimgcontainer">

                  <div className="martfigure">
                    <label>
                      <img
                        src={uploadedImages.pic1 || pic1}
                        alt="Matrimonial 1"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handlePhotoChange(e, "pic1")}
                      />
                    </label>
                  </div>

                  <div className="martfigure">
                    <label>
                      <img
                        src={uploadedImages.pic2 || pic2}
                        alt="Matrimonial 2"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handlePhotoChange(e, "pic2")}
                      />
                    </label>
                  </div>

                </div>

                <div className="rightpanelimgcontainer">
                  <div className="martfigure">
                    <label>
                      <img
                        src={uploadedImages.pic3 || pic3}
                        alt="Matrimonial 3"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handlePhotoChange(e, "pic3")}
                      />
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="col-100 profile-pic">
            {imageErrors && (
              <div className="error">
                {imageErrors}
              </div>
            )}
            <caption>Please attach 3 pictures as shown in the boxes.</caption>
          </div>

          <div className="col-100 text-center submission-div">
            <button type="submit" onClick={handleSubmit}>Submit</button>
            <p>
              Please check your mail after
              <br />
              successful submission
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrimonialRegistrationPage;
